import { createAction, props } from '@ngrx/store';
import { IServiceRegistration } from '../../../shared/model/service-registration.model';
import { IServiceRegistrationSearchFilter } from '../../../shared/model/service-registration-search-filter.model';
import { IOpportunity, OpportunityStatus } from "../../../shared/model/opportunity.model";
import { ISupervisor } from "../../../shared/model/supervisor.model";

export const findServiceRegistrations = createAction(
  '[Service Registrations] Find Registrations',
  props<{ searchFilter: IServiceRegistrationSearchFilter }>()
);

export const findServiceRegistrationsSuccess = createAction(
  '[Service Registrations] Find Registrations Success',
  props<{ registrations: IServiceRegistration[]; opportunityIds: string[] }>()
);

export const findServiceRegistrationsFailure = createAction(
  '[Service Registrations] Find Registrations Failure',
  props<{ error: string }>()
);

export const updateServiceRegistrations = createAction(
  '[Service Registrations] Update Registrations',
  props<{ registrations: IServiceRegistration[], noMessage?: boolean }>()
);

export const updateServiceRegistrationsSuccess = createAction(
  '[Service Registrations] Update Service Registrations Success',
  props<{ registrations: IServiceRegistration[]; noMessage?: boolean }>()
);

export const updateServiceRegistrationsFailure = createAction(
  '[Service Registrations] Update Service Registrations Failure',
  props<{ error: string }>()
);

export const updateServiceRegistrationWithSupervisor = createAction(
  '[Service Registrations] Update Registration With Supervisor',
  props<{ registration: IServiceRegistration; supervisor: ISupervisor; recordType: string }>()
);

export const updateServiceRegistrationWithSupervisorSuccess = createAction(
  '[Service Registrations] Update Registration With Supervisor Success',
  props<{ registration: IServiceRegistration; supervisor: ISupervisor; recordType: string }>()
);

export const updateServiceRegistrationWithSupervisorFailure = createAction(
  '[Service Registrations] Update Registration With Supervisor Failure',
  props<{ error: any; supervisor: ISupervisor; recordType: string }>()
);

export const findServiceRegistrationsWithOpportunityIds = createAction(
  '[Service Registrations] Find With Opportunity Ids',
  props<{ searchFilter: IServiceRegistrationSearchFilter; opportunityIds: string[] }>()
);

export const findServiceRegistrationsForOpportunitiesByStatus = createAction(
  '[Opportunities] Load Action Items By Status',
  props<{ opportunities: IOpportunity[]; supervisorId: string; status: OpportunityStatus }>()
);

export interface UpdateServiceRegistrationsSuccessPayload {
  registrations: IServiceRegistration[];
  noMessage?: boolean;
}
